import { render, staticRenderFns } from "./DeleteMapping.vue?vue&type=template&id=93b11d5e&scoped=true"
import script from "./DeleteMapping.vue?vue&type=script&lang=js"
export * from "./DeleteMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b11d5e",
  null
  
)

export default component.exports